import type { FaireProductEntity } from "../../entity_types/product";

export const p_6mtc47gewb: FaireProductEntity = {
  token: "p_6mtc47gewb",
  type: "product",
  name: 'A2 Tropical Hibiscus "Aloha" Greeting Card w/ Envelope',
  brandName: "Petals by Priya Watercolor Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/03c3417871541333b966af35426378bffdda7ed8a493bed54f9c080e0d9b916c.jpeg",
  priceDollars: 2.75,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/2be0b626c9366527b3b7b1e148beefa8793add0581ac4ef6c82065a0b10edbed.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
